import ScrollReveal from '../../../components/feature/ScrollReveal';

const dressColors = [
  { hex: '#6B1A2A', name: 'Бордовый', textColor: '#F5F0E8', label: '1' },
  { hex: '#E8D5C0', name: 'Бежевый', textColor: '#3D1F1A', label: '2' },
  { hex: '#3D1F1A', name: 'Эспрессо', textColor: '#E8D5C0', label: '3' },
  { hex: '#C9A0A8', name: 'Пыльная роза', textColor: '#3D1F1A', label: '4' },
];

export default function DressCode() {
  return (
    <section className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden" style={{ background: '#F5F0E8' }}>
      <div className="relative z-10 max-w-5xl mx-auto">

        <ScrollReveal direction="up">
          <div className="text-center mb-12 sm:mb-16 space-y-3">
            <h2 className="text-5xl sm:text-6xl md:text-7xl font-serif italic text-[#2A1A14]">
              Дресс-код
            </h2>
            <div className="flex items-center gap-3 justify-center pt-1">
              <div className="h-px w-12 bg-[#A8323C]/50" />
              <span className="text-[#A8323C] text-sm">✦</span>
              <div className="h-px w-12 bg-[#A8323C]/50" />
            </div>
            <p className="text-base text-[#6B5040] max-w-2xl mx-auto leading-relaxed pt-2">
              Будем рады, если вы поддержите атмосферу праздника
              в рекомендованной цветовой гамме.
            </p>
          </div>
        </ScrollReveal>

        {/* Color swatches — 2x2 on mobile, 4 columns desktop */}
        <ScrollReveal direction="up" delay={100}>
          <div className="grid grid-cols-2 sm:flex gap-3 sm:gap-4 sm:h-80 md:h-96">
            {dressColors.map((color, index) => (
              <div
                key={color.hex}
                className="relative overflow-hidden cursor-default transition-all duration-500
                           h-44 sm:h-auto sm:flex-1 sm:hover:flex-[1.6] border border-black/10"
                style={{ backgroundColor: color.hex }}
              >
                {/* Top-left number */}
                <div className="absolute top-3 left-4 text-xs font-serif italic opacity-40 select-none"
                  style={{ color: color.textColor }}>
                  {color.label}
                </div>

                {/* Bottom label with ornamental border */}
                <div className="absolute bottom-0 left-0 right-0 px-3 py-3"
                  style={{ borderTop: `1px solid ${color.textColor}20` }}>
                  <p className="text-xs tracking-[0.2em] uppercase font-mono text-center leading-tight"
                    style={{ color: color.textColor, opacity: 0.85 }}>
                    {color.name}
                  </p>
                </div>

                {/* Corner marks */}
                <span className="absolute top-2 right-3 text-[9px] opacity-20 select-none font-serif"
                  style={{ color: color.textColor }}>✦</span>
              </div>
            ))}
          </div>
        </ScrollReveal>

      </div>
    </section>
  );
}
